import axios from "axios";
import { getAxiosConfigWithToken } from "../helpers/functions_helper";
import * as url from "../helpers/url_helper";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class SplitPayroll {
  async create(data: any) {
    const response = await axios
      .put(SERVER_URL + url.SPLIT_PAYROLL.CREATE, data, {
        headers: getAxiosConfigWithToken(),
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
    return response;
  }

  async update(data: any) {
    const response = await axios
      .post(SERVER_URL + url.SPLIT_PAYROLL.UPDATE, data, {
        headers: getAxiosConfigWithToken(),
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
    return response;
  }

  async delete(data: any) {
    const response = await axios
      .post(SERVER_URL + url.SPLIT_PAYROLL.DELETE, data, {
        headers: getAxiosConfigWithToken(),
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
    return response;
  }

  async get(data: any) {
    const response = await axios
      .get(SERVER_URL + url.SPLIT_PAYROLL.GET + "/" + data.id + "/" + data.split_payroll_id, {
        headers: getAxiosConfigWithToken(),
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
    return response;
  }

  async getAll(data: any) {
    const response = await axios
      .post(SERVER_URL + url.SPLIT_PAYROLL.GET_ALL, data, {
        headers: getAxiosConfigWithToken(),
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
    return response;
  }

  async getSPYear() {
    const response = await axios
      .get(SERVER_URL + url.SPLIT_PAYROLL.GET_SP_YEAR, {
        headers: getAxiosConfigWithToken(),
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
    return response;
  }

  async getSPCountry() {
    const response = await axios
      .get(SERVER_URL + url.SPLIT_PAYROLL.GET_SP_COUNTRY, {
        headers: getAxiosConfigWithToken(),
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
    return response;
  }

  async exportReport(data: any) {
    const response = await axios
      .post(SERVER_URL + url.SPLIT_PAYROLL.REPORT, data, {
        headers: getAxiosConfigWithToken(),
        responseType: 'blob',
      }).then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
    return response;
  }

  //Graph
  async getDailyCounter(query:any) {
    const response = await axios
      .get(SERVER_URL + url.SPLIT_PAYROLL.GET_DAILY_COUNTER, {
        headers: getAxiosConfigWithToken(),
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
    return response;
  }

  async getCompanyVsIndividual(query:any) {
    const response = await axios
      .get(SERVER_URL + url.SPLIT_PAYROLL.GET_COMPANY_VS_INDIVIDUAL+'?'+query, {
        headers: getAxiosConfigWithToken(),
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
    return response;
  }

  async getSplitPayrollCreatedByCompany(query:any) {
    const response = await axios
      .get(SERVER_URL + url.SPLIT_PAYROLL.GET_CREATED_BY_COMPANY+'?'+query, {
        headers: getAxiosConfigWithToken(),
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
    return response;
  }


 

}

export default new SplitPayroll();
